import { Stack, Typography, } from '@mui/material';
import * as React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { getUserDetailsAction } from '../../../../redux/user/getUserDetails';
import Quizwall from '../../../../assets/theme6/quizwall.png'

import Arrow from '../../../../assets/theme6/arrow_back2.png'
import Fav from '../../../../assets/theme6/fav.png'
import Style from '../style/appbar.module.scss'
import favoriteIcon from '../../../../assets/img/favorite-icon.png'

const Appbar = () => {

    const dispatch = useDispatch()
    const navigate = useNavigate()
    const { pathname } = useLocation();


    const userDetialsSelector = useSelector(state => state.getUserDetails)
    const { data } = userDetialsSelector



    // fn


    React.useEffect(() => {
        dispatch(getUserDetailsAction())
    }, [])

    const handleLogout = () => {
        // localStorage.removeItem('pwa_user_id')
        // localStorage.removeItem('pwa_publisher_id')
        localStorage.removeItem('pwa_token')
        localStorage.removeItem('pwa_app_theme')
        localStorage.removeItem('pwa_app_id')
        window.location.reload();

    }
    const backHistory = () => {
        if (pathname.includes('/home')) {
            // Redirect to a new URL
            window.location.href = localStorage.getItem('referringURL');

        } else {
            navigate(-1)
        }
    }
    return (
        <>
            <div className={Style.container}>


                <div>
                    <Stack direction="row" sx={{position:"relative", padding: "33px 22px 100px",height : "auto", display: "flex", justifyContent: 'space-between', alignItems : "center" }}>
                        <div style={{ display: 'flex', gap: "5px", alignItems : "center" , height: "fit-content"}}>
                            <div className="typo" style={{  color: "#000",zIndex:2 ,width : "25px" , height : "25px"}} onClick={backHistory}><img src={Arrow} style={{width:"100%",height:"100%"}}/></div>
                            <div className="typo" style={{  color: "#000",zIndex:2 }}  onClick={backHistory}><img width={"143px"} src={Quizwall}/></div>
                        </div>
                       { pathname.includes('/favorite')===false &&  <div style={{display:'flex',alignItems:"center",justifyContent:"center",zIndex:"10"}} onClick={()=>{navigate('/favorite')}}>
                           <img src={favoriteIcon} width={"36px"}/>
                        </div>}


                    </Stack>
                </div>

            </div>
        </>
    )
}


export default Appbar